function checkPublicEmailDomains(email) {
  const publicDomains = [
    "gmail.com",
    "yahoo.com",
    "mail.ru",
    "mail.com",
    "msn.com",
    "yandex.ru",
    "hotmail.com",
    "icloud.com"
  ];
  return publicDomains.some((domain) => email.includes(`@${domain}`));
}
var checkPublicEmailDomains_default = checkPublicEmailDomains;
export {
  checkPublicEmailDomains_default as default
};
